import { useState, useEffect, useRef } from 'react';

type UseIntersectionObserverHook = {
  isIntersecting: boolean;
  targetRef: React.MutableRefObject<null>;
};

const useIntersectionObserver = (
  options: IntersectionObserverInit = { threshold: 0.1 }
): UseIntersectionObserverHook => {
  const [isIntersecting, setIsIntersecting] = useState(false);
  const targetRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      setIsIntersecting(entry.isIntersecting);
    }, options);

    if (targetRef.current) {
      observer.observe(targetRef.current);
    }

    return () => {
      if (targetRef.current) {
        observer.unobserve(targetRef.current);
      }
    };
  }, [options]);

  return { isIntersecting, targetRef };
};

export default useIntersectionObserver;
